// extracted by mini-css-extract-plugin
module.exports = {"separator":"MenuItemSeparator-separator-1ayq0"};